import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDossier: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDossier"><Path d="M2 4H8V9.5H22V20H2V4Z" fill="currentColor"/><Path d="M9.5 4H15V8H9.5V4Z" fill="currentColor"/><Path d="M16.5 4H22V8H16.5V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDossier;
